import { useTranslation } from 'react-i18next';
import React, { useEffect, useRef, useState } from 'react';
// import { Swiper as SwiperType } from 'swiper/types';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';

import Card from '../../gcompts/Card';
import Footer from '../../components/Footer/Footer';
import UnifiedNavigation from '../../components/Navigation/UnifiedNavigation';
import InstagramSection from '../../components/BrandHomePage/InstagramSection';

import './ExperiencesPage.css';
// import { images } from '../../components/shared/assets';


const ExperiencePage: React.FC = () => {
  const [activePage, setActivePage] = useState(0);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const gridRef = useRef<HTMLDivElement | null>(null);
  // const swiperRef = useRef<SwiperType | null>(null);


  const { t } = useTranslation();

  const propertyTypes = [
    {
      label: 'ATACAMA',
      labelDropdown: 'ATACAMA, CHILE',
      value: 'atacama',
    },
    {
      label: 'PATAGONIA',
      labelDropdown: 'PATAGONIA, CHILE',
      value: 'patagonia',
    },
    {
      label: 'IGUAZU',
      labelDropdown: 'IGUAZU, ARGENTINA',
      value: 'iguazu',
    },
    {
      label: 'MENDOZA',
      labelDropdown: 'MENDOZA, ARGENTINA',
      value: 'mendoza',
    },
    {
      label: 'SANTA CATARINA',
      labelDropdown: 'SANTA CATARINA, BRAZIL',
      value: 'santa-catarina',
    }
  ];

  const data = [
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.0.propertyName' as any),
      title: t('properties/atacama:experiences.activities.0.title' as any),
      description: t('properties/atacama:experiences.activities.0.description' as any),
      image: '/assets/images/experiences/atacama/experience-atacama-03.jpg'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.1.propertyName' as any),
      title: t('properties/atacama:experiences.activities.1.title' as any),
      description: t('properties/atacama:experiences.activities.1.description' as any),
      image: '/assets/images/experiences/atacama/outro-large.png'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.2.propertyName' as any),
      title: t('properties/atacama:experiences.activities.2.title' as any),
      description: t('properties/atacama:experiences.activities.2.description' as any),
      image: '/assets/images/experiences/atacama/b5543381f5ba7af0dff3d7541a76d9c51b32375a.png'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.3.propertyName' as any),
      title: t('properties/atacama:experiences.activities.3.title' as any),
      description: t('properties/atacama:experiences.activities.3.description' as any),
      image: '/assets/images/experiences/atacama/b511fc05b56f6f56ab808fe346dacf0108ddd079.png'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.4.propertyName' as any),
      title: t('properties/atacama:experiences.activities.4.title' as any),
      description: t('properties/atacama:experiences.activities.4.description' as any),
      image: '/assets/images/experiences/atacama/beb9d9b0edfbf7775d28175268e31dd71c205b7e.png'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.5.propertyName' as any),
      title: t('properties/atacama:experiences.activities.5.title' as any),
      description: t('properties/atacama:experiences.activities.5.description' as any),
      image: '/assets/images/experiences/atacama/hero-landscape.png'
    },
    {
      property: 'atacama',
      propertyName: t('properties/atacama:experiences.activities.6.propertyName' as any),
      title: t('properties/atacama:experiences.activities.6.title' as any),
      description: t('properties/atacama:experiences.activities.6.description' as any),
      image: '/assets/images/experiences/atacama/db2d298042f42082c14f5bd1c9192a1883c2b1c7.png'
    },

    //patagonia
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.0.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.0.title' as any),
      description: t('properties/patagonia:experiences.activities.0.description' as any),
      image: '/assets/images/experiences/patagonia/Kotula Trail.jpg'
    },
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.1.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.1.title' as any),
      description: t('properties/patagonia:experiences.activities.1.description' as any),
      image: '/assets/images/experiences/patagonia/Base Torres.jpg'
    },
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.2.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.2.title' as any),
      description: t('properties/patagonia:experiences.activities.2.description' as any),
      image: '/assets/images/experiences/patagonia/Grey Glacier Lookout.jpg'
    },
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.3.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.3.title' as any),
      description: t('properties/patagonia:experiences.activities.3.description' as any),
      image: '/assets/images/experiences/patagonia/Horseback Riding.jpg'
    },
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.4.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.4.title' as any),
      description: t('properties/patagonia:experiences.activities.4.description' as any),
      image: '/assets/images/experiences/patagonia/059dfcb228828844d4655dd823efa51cd0eab3fd.png'
    },
    {
      property: 'patagonia',
      propertyName: t('properties/patagonia:experiences.activities.5.propertyName' as any),
      title: t('properties/patagonia:experiences.activities.5.title' as any),
      description: t('properties/patagonia:experiences.activities.5.description' as any),
      image: '/assets/images/experiences/patagonia/8ee17c93e20bdf0a88d5b91872820aefdb98b0ad.png'
    },

    //iguazu
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.0.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.0.title' as any),
      description: t('properties/iguazu:experiences.activities.0.description' as any),
      image: '/assets/images/experiences/iguazu/Mbya Guaraní Community.jpg'
    },
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.1.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.1.title' as any),
      description: t('properties/iguazu:experiences.activities.1.description' as any),
      image: '/assets/images/experiences/iguazu/Yacui Private Reserve.jpg'
    },
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.2.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.2.title' as any),
      description: t('properties/iguazu:experiences.activities.2.description' as any),
      image: '/assets/images/experiences/iguazu/e92bcf5fe29d20010c290356554fabec03e68759.png'
    },
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.3.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.3.title' as any),
      description: t('properties/iguazu:experiences.activities.3.description' as any),
      image: '/assets/images/experiences/iguazu/Choose your pace.jpg'
    },
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.4.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.4.title' as any),
      description: t('properties/iguazu:experiences.activities.4.description' as any),
      image: '/assets/images/experiences/iguazu/7709e9208fb2fbf34bbce60468876a45e63307a3.png'
    },
    {
      property: 'iguazu',
      propertyName: t('properties/iguazu:experiences.activities.5.propertyName' as any),
      title: t('properties/iguazu:experiences.activities.5.title' as any),
      description: t('properties/iguazu:experiences.activities.5.description' as any),
      image: '/assets/images/experiences/iguazu/Iguazú National Park.jpg'
    },

    //mendoza
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.0.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.0.title' as any),
      description: t('properties/mendoza:experiences.activities.0.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-70.jpg'
    },
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.1.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.1.title' as any),
      description: t('properties/mendoza:experiences.activities.1.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-42.jpg'
    },
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.2.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.2.title' as any),
      description: t('properties/mendoza:experiences.activities.2.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-264.jpg'
    },
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.3.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.3.title' as any),
      description: t('properties/mendoza:experiences.activities.3.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-121.jpg'
    },
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.4.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.4.title' as any),
      description: t('properties/mendoza:experiences.activities.4.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-230.jpg'
    },
    {
      property: 'mendoza',
      propertyName: t('properties/mendoza:experiences.activities.5.propertyName' as any),
      title: t('properties/mendoza:experiences.activities.5.title' as any),
      description: t('properties/mendoza:experiences.activities.5.description' as any),
      image: '/assets/images/experiences/mendoza/AWASI - MENDOZA-122.jpg'
    },

    //santa-catarina
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.0.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.0.title' as any),
      description: t('properties/santa-catarina:experiences.activities.0.description' as any),
      image: '/assets/images/experiences/santa-catarina/AWASI - SANTA CATARINA-5.jpg'
    },
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.1.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.1.title' as any),
      description: t('properties/santa-catarina:experiences.activities.1.description' as any),
      image: '/assets/images/experiences/santa-catarina/Ilha-de-anhatomirim.jpg'
    },
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.2.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.2.title' as any),
      description: t('properties/santa-catarina:experiences.activities.2.description' as any),
      image: '/assets/images/experiences/santa-catarina/AWASI - SANTA CATARINA-75.jpg'
    },
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.3.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.3.title' as any),
      description: t('properties/santa-catarina:experiences.activities.3.description' as any),
      image: '/assets/images/experiences/santa-catarina/AWASI - SANTA CATARINA-61.jpg'
    },
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.4.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.4.title' as any),
      description: t('properties/santa-catarina:experiences.activities.4.description' as any),
      image: '/assets/images/experiences/santa-catarina/AWASI - SANTA CATARINA-122.jpg'
    },
    {
      property: 'santa-catarina',
      propertyName: t('properties/santa-catarina:experiences.activities.5.propertyName' as any),
      title: t('properties/santa-catarina:experiences.activities.5.title' as any),
      description: t('properties/santa-catarina:experiences.activities.5.description' as any),
      image: '/assets/images/experiences/santa-catarina/ciudad-de-florianopolis.png'
    },
  ]

  // const guides = [
  //   {
  //     property: 'atacama',
  //     propertyName: t('properties/atacama:experiences.team.members.0.role' as any),
  //     title: t('properties/atacama:experiences.team.members.0.name' as any),
  //     description: t('properties/atacama:experiences.team.members.0.description' as any),
  //     image: '/assets/images/team/carlos-barros.jpg'
  //   },
  //   {
  //     property: 'atacama',
  //     propertyName: t('properties/atacama:experiences.team.members.1.role' as any),
  //     title: t('properties/atacama:experiences.team.members.1.name' as any),
  //     description: t('properties/atacama:experiences.team.members.1.description' as any),
  //     image: '/assets/images/team/cristian-lopez.jpg'
  //   },
  //   {
  //     property: 'atacama',
  //     propertyName: t('properties/atacama:experiences.team.members.2.role' as any),
  //     title: t('properties/atacama:experiences.team.members.2.name' as any),
  //     description: t('properties/atacama:experiences.team.members.2.description' as any),
  //     image: '/assets/images/team/paula-bertotto.png'
  //   },
  //   {
  //     property: 'atacama',
  //     propertyName: t('properties/atacama:experiences.team.members.3.role' as any),
  //     title: t('properties/atacama:experiences.team.members.3.name' as any),
  //     description: t('properties/atacama:experiences.team.members.3.description' as any),
  //     image: '/assets/images/team/marco-salinas.png'
  //   },
  //   {
  //     property: 'patagonia',
  //     propertyName: t('properties/patagonia:experiences.team.members.0.role' as any),
  //     title: t('properties/patagonia:experiences.team.members.0.name' as any),
  //     description: t('properties/patagonia:experiences.team.members.0.description' as any),
  //     image: '/assets/images/team/carlos-barros.jpg'
  //   },
  //   {
  //     property: 'patagonia',
  //     propertyName: t('properties/patagonia:experiences.team.members.1.role' as any),
  //     title: t('properties/patagonia:experiences.team.members.1.name' as any),
  //     description: t('properties/patagonia:experiences.team.members.1.description' as any),
  //     image: '/assets/images/team/cristian-lopez.jpg'
  //   },
  //   {
  //     property: 'patagonia',
  //     propertyName: t('properties/patagonia:experiences.team.members.2.role' as any),
  //     title: t('properties/patagonia:experiences.team.members.2.name' as any),
  //     description: t('properties/patagonia:experiences.team.members.2.description' as any),
  //     image: '/assets/images/team/paula-bertotto.png'
  //   },
  //   {
  //     property: 'patagonia',
  //     propertyName: t('properties/patagonia:experiences.team.members.3.role' as any),
  //     title: t('properties/patagonia:experiences.team.members.3.name' as any),
  //     description: t('properties/patagonia:experiences.team.members.3.description' as any),
  //     image: '/assets/images/team/marco-salinas.png'
  //   },
  //   {
  //     property: 'patagonia',
  //     propertyName: t('properties/patagonia:experiences.team.members.4.role' as any),
  //     title: t('properties/patagonia:experiences.team.members.4.name' as any),
  //     description: t('properties/patagonia:experiences.team.members.4.description' as any),
  //     image: '/assets/images/team/marco-salinas.png'
  //   }
  // ]

  const [openFilters, setOpenFilters] = useState(false);
  const [activeProperty, setActiveProperty] = useState(0);
  const [dataVisible, setDataVisible] = useState([] as any[]);
  // const [guidesVisible, setGuidesVisible] = useState([] as any[]);


  // const handleArrowClick = (direction: 'left' | 'right') => {
  //   if (swiperRef.current) {
  //     if (direction === 'left') {
  //       swiperRef.current?.slidePrev();
  //     } else {
  //       swiperRef.current?.slideNext();
  //     }
  //   }
  // };

  const contentByProperties = (properties: string[]) => {
    return data.filter(item => properties.includes(item.property));
  };

  // const guidesByProperties = (properties: string[]) => {
  //   return guides.filter(item => properties.includes(item.property));
  // };

  const goToContactPage = () => {
    window.location.href = '/contact';
  }

  const goToGuides = () => {
    const guides = document.getElementById('ep-guides');
    if (guides) {
      guides.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handleSetPage = (pageIndex: number) => {
    setActivePage(pageIndex);
    gridRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const currentRouteHash = window.location.hash;
    console.log('Current route hash:', currentRouteHash, propertyTypes.findIndex(pt => `#${pt.value}` === currentRouteHash));
    const position = propertyTypes.findIndex(pt => `#${pt.value}` === currentRouteHash)
    setActiveProperty(position >= 0 ? position : 0);

    const handleClickOutside = (event: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
        setOpenFilters(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    setDataVisible(contentByProperties([propertyTypes[activeProperty].value]));
    // setGuidesVisible(guidesByProperties([propertyTypes[activeProperty].value]));
    setActivePage(0);
  }, [activeProperty]);

  return (
    <div>
      <UnifiedNavigation variant="dark" />

      <div className='ep-title'>
        <h1 className='ep-title-text'>{t('properties/atacama:experiences.pageTitle' as any)}</h1>
        <div className='ep-title-subtext'>{t('properties/atacama:experiences.pageDescription' as any)}</div>
      </div>

      <div className="ep-fullwidth">
        <img src="/assets/images/atacama/video4.png" alt="Hero" />
      </div>

      <div className="ep-grid-wrapper">
        <div className="ep-grid-filters">
          <div className="ep-grid-filters-side">
            <div className='ep-grid-filters-dropdown-wrapper' ref={dropdownRef}>
              <div className={`ep-grid-filters-item ${openFilters ? 'open' : ''}`} onClick={() => setOpenFilters(!openFilters)}>
                {propertyTypes[activeProperty].label} +
              </div>
              <div className={`ep-grid-filters-item-dropdown ${openFilters ? 'open' : ''}`}>
                {propertyTypes.map((type, index) => (
                  <div
                    className='ep-grid-filters-item-dropdown-item'
                    key={`ep-filter-${type.value}`}
                    onClick={() => {
                      setActiveProperty(index)
                      setOpenFilters(false);
                    }}
                  >
                    {type.labelDropdown}
                  </div>
                ))}
              </div>
            </div>

          </div>
          {/* <div className="ep-grid-filters-side">
            <div className="ep-grid-filters-item" onClick={goToGuides}>OUR GUIDES</div>
          </div> */}
        </div>

        <div className="ep-grid" ref={gridRef} style={{ transform: `translateX(-${activePage * 100}vw)` }}>
          {Array.from({ length: Math.ceil(dataVisible.length / 6) }).map((_, index) =>
            <div className="ep-grid-slide">
              {dataVisible.slice(index * 6, index * 6 + 6).map((item, itemIndex) =>
                <Card
                  key={`ep-card-${index}-${item.title}`}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                  property={item.propertyName}
                  goToContact={goToContactPage}
                />
              )}
            </div>
          )}
        </div>


        {
          dataVisible.length > 1 && (
            <div className="ep-grid-pagination">
              {Array.from({ length: Math.ceil(dataVisible.length / 6) }).map((_, index) => (
                <div className={`ep-grid-pagination-item ${activePage === index && 'is-active'}`} key={`ep-pagination-${index}`} onClick={() => handleSetPage(index)}>
                  {index + 1}
                </div>
              ))}
            </div>
          )
        }
      </div>


      {/* {guidesVisible.length > 0 &&
        <div className="ep-guides glacier-video-exploration__carousel-container" id="ep-guides">
          <Swiper
            freeMode
            navigation
            spaceBetween={20}
            slidesPerView={1}
            className='ep-guides-swiper'
            breakpoints={{
              1024: {
                slidesPerView: 3,
                spaceBetween: 30,
              },
              786: {
                slidesPerView: 2,
                spaceBetween: 30,
              },
            }}
            onSwiper={(currentSwiper: SwiperType) => swiperRef.current = currentSwiper}
          >
            {guidesVisible.map((item, index) =>
              <SwiperSlide key={`ep-card-${index}-${item.title}`}>
                <Card
                  key={`ep-card-${index}-${item.title}`}
                  title={item.title}
                  description={item.description}
                  image={item.image}
                  property={item.propertyName}
                />
              </SwiperSlide>
            )}
          </Swiper>
          <div className="glacier-video-exploration__arrow left" onClick={() => handleArrowClick('left')}>
            <img
              src={images.carouselArrow}
              alt="Scroll to see more destinations"
              className="glacier-video-exploration__arrow-image"
            />
          </div>

          <div className="glacier-video-exploration__arrow" onClick={() => handleArrowClick('right')}>
            <img
              src={images.carouselArrow}
              alt="Scroll to see more destinations"
              className="glacier-video-exploration__arrow-image"
            />
          </div>
        </div>
      } */}

      <div className="ep-fullwidth">
        <img src="/assets/images/atacama/video1.png" alt="Hero" />
      </div>

      <InstagramSection />
      <Footer />
    </div>
  );
};

export default ExperiencePage;